
/**
 * Clase para manejar los eventos de las peticiones de SBSuite
 *
 * @export
 * @class SBSuiteEvents
 */
export class SBSuiteEvents{


    /**
     * Compendio de eventos de sbSuite
     *
     * @static
     * @memberof SBSuiteEvents
     */
    static readonly EVENTS = {
        CAMBIAR_OPERARIO_INIT: 'operator:loading',
        CAMBIAR_OPERARIO_END: 'operator:loaded',
        CAMBIAR_OPERARIO_OFS: 'opeator:stop',
        CAMBIAR_OPERARIO_FAIL: 'operator:fail',
        CURRENT_OF_DETECTED: 'of:current',
        LAST_OF_DETECTED: 'of:last',
        NO_OF_DETECTED: 'of:empty',
        CAMBIAR_OF_INIT: 'of:loading',
        CAMBIAR_OF_END: 'of:loaded',
        CAMBIAR_OF_FAIL: 'of:fail',
        PRODUCTO_OF_INIT: 'product:loading',
        PRODUCTO_OF_END: 'product:loaded',
        PRODUCTO_OF_FAIL: 'product:fail',
        OPERACION_PROD_INIT: 'operation:loading',
        OPERACION_PROD_END: 'operation:loaded',
        OPERACION_PROD_FAIL: 'operation:fail',
        CONTINUE_OF_INIT: 'continue:loading',
        CONTINUE_OF_END: 'continue:loaded',
        CONTINUE_OF_FAIL: 'continue:fail',
        EXIT_OPERATOR_INIT: 'exit:loading',
        EXIT_OPERATOR_END: 'exit:loaded',
        EXIT_OPERATOR_FAIL: 'exit:fail',
        OFS_INIT: 'ofs:loading',
        OFS_END: 'ofs:loaded',
        OFS_FAIL: 'ofs:fail',
        INTERNAL_LIST_INIT: 'internal:loading',
        INTERNAL_LIST_END: 'internal:loaded',
        INTERNAL_LIST_FAIL: 'internal:fail',
        HISTORY_INIT: 'history:loading',
        HISTORY_END: 'history:loaded',
        HISTORY_FAIL: 'history:fail',
        DROPDOWNS_INIT: 'dropdow:loading',
        DROPDOWNS_END: 'dropdow:loaded',
        DROPDOWNS_FAIL: 'dropdow:fail',
        UPDATE_REG_INIT: 'update:init',
        UPDATE_REG_END: 'update:end',
        UPDATE_REG_FAIL: 'update:fail',
        CREATE_REG_INIT: 'create:init',
        CREATE_REG_END: 'create:end',
        CREATE_REG_FAIL: 'create:fail',
        DELETE_REG_INIT: 'delete:init',
        DELETE_REG_END: 'delete:end',
        DELETE_REG_FAIL: 'delete:fail',
        LOGIN_INIT: 'login:loading',
        LOGIN_END: 'login:loaded',
        LOGIN_FAIL: 'login:fail',
        AUTH_INIT: 'auth:loading',
        AUTH_END: 'auth:loaded',
        AUTH_FAIL: 'auth:fail',
        OF_FOCUS: 'of:focus',
        APP_LOADED: 'app:loaded',
        DEFINE_NEW_INIT: 'define:loading',
        DEFINE_NEW_END: 'define:loaded',
        DEFINE_NEW_FAIL: 'define:fail',
        LOGO_INIT: 'logo:loading',
        LOGO_END: 'logo:loaded',
        LOGO_FAIL: 'logo:fail'

        
    };

    /**
     * Valor de timeout para las peticiones
     *
     * @static
     * @memberof SBSuiteEvents
     */
    static readonly EVENT_DURATION = 5000;


    /**
     * Crea una instáncia de SBSuite
     * @memberof SBSuiteEvents
     */
    constructor(){
    }


    /**
     *
     * @deprecated Eliminar??
     * @param {string} [param1='']
     * @param {string} [param2='']
     * @memberof SBSuiteEvents
     */
    genEventName(param1: string = '', param2: string = ''){
        if(param2) param1 = param1 + ':' + param2  ;
    }


    /**
     *
     * @deprecated Eliminar??
     * @param {string} event
     * @returns
     * @memberof SBSuiteEvents
     */
    is(event: string){
        let aEvent = event.split(':');
        if(aEvent[0] == event ) return true;
        if(aEvent.length < 2) return false;
        if(aEvent[1] == event ) return true;
        return false;

    }


}


// WEBPACK FOOTER //
// ./src/modules/sbsuite/models/sbsuite.events.ts